import PropTypes from 'prop-types'
import { useEffect, useState } from 'react';

const Input = ({ label, icon, onChange, placeholder, type, name, value, error, disabled=false, onFocus, required=false, maxLength, autocomplete }) => {
    const [showNumber, setShowNumber] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
          setShowNumber(true);
        }, 5000); // 5000 milisaniye = 5 saniye
      
        return () => clearTimeout(timer);
      }, []);

    return (
        <div className="form-control">
            {label && <label className="form-control-label">{label} {required && "*"}</label>}
            <input onFocus={onFocus} disabled={disabled} autoComplete={autocomplete ? autocomplete : 'off'} maxLength={maxLength} name={name} value={value} onChange={e => { 
        if (maxLength && e.target.value.length < maxLength + 1) {
          onChange(e)
        } else if (!maxLength) {
          onChange(e)
        }
      }} type={type} placeholder={placeholder ? placeholder : 'Placeholder'} className="form-control-input" />
            {(error && !showNumber) && <div className='text-danger ml-2'>{error}</div>}
            {icon && icon}
        </div>
    )
}
Input.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    icon: PropTypes.node,
    onChange: PropTypes.func
}
export default Input